import { type ReactNode, forwardRef } from 'react';
import {
  AppBar,
  Container,
  Dialog,
  type DialogProps,
  IconButton,
  Toolbar,
  Typography,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import { Slide } from '@mui/material';

import { type FormProps } from '#packages/web/types/form-props';

const Transition = forwardRef(function Transition(
  props: React.ComponentProps<typeof Slide>,
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" enter exit ref={ref} {...props} />;
});

export type SelectDialogProps<TValue = unknown> = DialogProps &
  FormProps<TValue> & {
    /**
     * Title to display at the top of the dialog.
     */
    title: ReactNode;
  };

export const SelectDialog = <TValue,>({
  title,
  initialValue,

  onFormCancel,
  onFormSubmit,

  children,

  ...props
}: SelectDialogProps<TValue>) => {
  return (
    <Dialog
      fullScreen
      maxWidth="sm"
      // transitionDuration={{ enter: 0, exit: 0, appear: 0 }}
      slots={{
        transition: Transition,
      }}
      {...props}>
      <AppBar sx={{ position: 'relative' }}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={onFormCancel}
            aria-label="close">
            <Close />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="sm">{children}</Container>
    </Dialog>
  );
};
